import logo from "../../assets/recode_pro-logo-1.svg";
import { useState } from "react";
// import Papa from "papaparse";
import styles from "./Termos.module.scss";
import { AlignCenter, InputAreaDupla } from "../../components/Box/Box";
// import { InputFile } from "../../components/Input/InputFile";
import { ContainedBtn } from "../../components/ButtonTypes/Button";
// import { swalTheme } from "../../services/Swal";
// import Swal from "sweetalert2";
import { Toast, swalTheme } from "../../services/Swal";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import Checkbox from "../../components/Checkbox/Checkbox";
import Swal from "sweetalert2";

function Termos() {
  let valido = false;
  const [form, setForm] = useState({});
  const { idestudante } = useParams();
  const [termos, setTermos] = useState([]);
  const [loading, setLoading] = useState(false);

  const dataAtual = new Date().getTime();
  const dataFinal = new Date("2023-06-08 00:00:00").getTime()

  useEffect(() => {
    try {
      let decodedId = atob(idestudante);

      fetch(
        `${process.env.REACT_APP_BACKEND}/api/RecodePro/AceitaTermos?IdEstudante=${decodedId}`
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data.payload)
          setTermos(data.payload);
        });
    } catch (error) {
      console.error("error", error)
    }

  }, [idestudante]);

  function validaTermos() {
    const termosObrigatorios = termos.filter((termo) => termo.obrigatorio);
    valido = true

    termosObrigatorios.map((termo) => {
      return !form.termos?.[termo.nome] ? (valido = false) : null;
    });
  }

  if (dataAtual >= dataFinal) return (
    <>
      <section>
        <AlignCenter>
          <img src={logo} className={styles.logo} alt="logo" />
        </AlignCenter>

        <AlignCenter>
          <h1>Período de matrícula encerrado!</h1>
        </AlignCenter>
      </section>
    </>
  );

  if (termos.length === 0) return (
    <section>
      <AlignCenter>
        <img src={logo} className={styles.logo} alt="logo" />
      </AlignCenter>

      <AlignCenter>
        <h1>Olá, parabéns pela aprovação!</h1>
      </AlignCenter>

      <AlignCenter>
        <h2>Você não possui termos para aceitar.</h2>
      </AlignCenter>
    </section>
  )

  return (
    <>
      <section>
        <AlignCenter>
          <img src={logo} className={styles.logo} alt="logo" />
        </AlignCenter>

        <AlignCenter>
          Olá! Leia com atenção os termos disponibilizados abaixo e indique seu aceite para formalização de sua matrícula no Recode Pro 2023.
        </AlignCenter>

      </section>

      <form
        onSubmit={(e) => {
          e.preventDefault();

          validaTermos();
          if (!valido) return Toast.fire({
            icon: "error",
            title: "Você precisa aceitar todos os termos obrigatórios",
          })

          setLoading(true)

          const termosEnviar = [];
          Object.keys(form?.termos).map((termo) => {
            return termosEnviar.push({
              nome: termo,
              aceite: form?.termos[termo],
            });
          });

          const body = { idEstudante: atob(idestudante), termos: termosEnviar }
          console.log(body)

          fetch("https://plataforma.recode.org.br/api/api/RecodePro/AceitaTermos", {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          })
            .then(response => response.json())
            .then(result => {
              if (result.success)
                return Swal.fire({
                  title: "Sucesso!",
                  text: "Você aceitou os termos!",
                  icon: "success",
                  ...swalTheme,
                }).then(() => {
                  window.location.replace("https://www.recodepro.org.br/");
                });

              return Swal.fire({
                title: "Erro",
                text: result.message,
                icon: "error",
                ...swalTheme,
              });
            })
            .catch(error => {
              console.log("error", error);
              Swal.fire({
                title: "Erro",
                text: "Um erro ocorreu!",
                icon: "error",
                ...swalTheme,
              });
            }).finally(() => setLoading(false));

        }}
      >
        {
          termos.sort((a, b) => a.obrigatorio > b.obrigatorio ? 1 : b.obrigatorio > a.obrigatorio ? -1 : 0)
            .map((termo, index) => (
              <InputAreaDupla key={index}>
                <Checkbox
                  key={termo.nome}
                  className={styles.checkbox}
                  // value={form[termo.nome]}
                  checked={form?.termos?.[termo?.nome]}
                  onChange={(e) => {
                    setForm({
                      ...form,
                      termos: {
                        ...form.termos,
                        [termo.nome]: e.target.checked,
                      },
                    });
                  }}
                  required
                >
                  <span>
                    {termo.descricao}
                    {termo.obrigatorio && "* "}
                    {termo.link && (
                      <a
                        className={styles.checkboxA}
                        rel="noreferrer"
                        href={termo.link}
                        target="_blank"
                      >
                        <FontAwesomeIcon
                          icon={faUpRightFromSquare}
                          className={styles.icon}
                        />
                      </a>
                    )}
                  </span>
                </Checkbox>
              </InputAreaDupla>
            ))
        }

        <ContainedBtn className={styles.button} disabled={loading}>{loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Enviar"}</ContainedBtn>
      </form>
    </>
  );
}

export default Termos;
